import { AiRouterApi } from '@calm/evexia-web-sdk/generated/lib/api/ai-router-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `AiRecommendationsApi`
 * @param accessToken
 * @returns
 */
export default function createAiRouterApi(accessToken: () => Promise<string>) {
    return createApi(AiRouterApi, accessToken);
}
